'use strict';

import 'google';

export default function () {
  'ngInject';

  return {
    scope: {
      mapData: '<',
      mapTypeId: '<',
      zoom: '<',
    },
    link: link,
  };

  function link(scope, element, attrs, ctrls) {
    const map = new google.maps.Map(element[0], {
      zoom: scope.zoom,
      center: { lat: 0, lng: 0 },
      disableDefaultUI: true,
    });
    updateMap(map, scope.mapData);
    scope.$watch('mapData', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        updateMap(map, newValue);
      }
    });
  }
}

function updateMap(map, mapData) {
  const bounds = new google.maps.LatLngBounds();
  const boundsListener = map.data.addListener('addfeature', function (e) {
    processPoints(e.feature.getGeometry(), bounds.extend, bounds);
    map.fitBounds(bounds);
  });
  map.data.forEach((f) => {
    map.data.remove(f);
  });
  mapData.forEach((data) => {
    if (data.type === 'GeoJson') {
      if (typeof data.features === 'string') {
        data.features = JSON.parse(data.features);
      }
      map.data.addGeoJson(data.features);
      if (data.color) {
        map.data.setStyle({
          fillColor: data.color,
          strokeColor: data.color,
        });
      }
    }
    else {
      console.error('Unsupported data type:', data.type);
    }
  });
  google.maps.event.removeListener(boundsListener);
}

function processPoints(geometry, callback, thisArg) {
  if (geometry instanceof google.maps.LatLng) {
    callback.call(thisArg, geometry);
  } else if (geometry instanceof google.maps.Data.Point) {
    callback.call(thisArg, geometry.get());
  } else {
    geometry.getArray().forEach((g) => processPoints(g, callback, thisArg));
  }
}
